export const ResetPasswordErrorCodeEnum = {
  InvalidEmail: 'auth/invalid-email',
  UserNotFound: 'auth/user-not-found',
};